
import { Injectable } from '@angular/core';
import { GfTranslateService } from '../../../services/core.translate.service';

import * as _ from 'lodash-es';
import { FeatureFlagService } from '../../../services/core.feature-flags.service';
import { marker } from '../../../services/ngx-translate-extract-marker';

@Injectable()
export class AdminHeaderService {
    private menuData = [];

    constructor(
        private gfTranslateService: GfTranslateService,
        private featureFlagService: FeatureFlagService,
    ) {
        const menuData = [
            this.createMenuItem(marker('Users'), 'home.admin.users', 'glyph-img-user'),
            this.createMenuItem(marker('Projects'), 'home.admin.projects', 'glyph-img-project'),
            this.createMenuItem(marker('Repositories'), 'home.admin.scm', 'glyph-img-git'),
            this.menuSeparator(),
            this.createMenuItem(marker('Groups'), 'home.admin.groups', 'glyph-img-group'),
            this.createMenuItem(marker('Orgs'), 'home.admin.orgs', 'glyph-img-org'),
            this.createMenuItem(marker('Categories'), 'home.admin.trove', 'glyph-img-org-2'),
            this.menuSeparator(),
            this.createMenuItem(marker('Snapshots'), 'home.admin.snapshots', 'glyph-img-snapshot'),
            this.createMenuItem(marker('Homepage'), 'home.admin.homepage', 'glyph-img-wiki'),
            this.createMenuItem(marker('Authentication'), 'home.admin.authentication', 'glyph-img-cicd'),
            this.createMenuItem(marker('Site Notifications'), 'home.admin.sitenotification', 'glyph-img-notification'),
            this.menuSeparator(),
            this.createMenuItem(marker('Reports'), 'home.admin.reports', 'glyph-img-report'),
            this.createMenuItem(marker('Cronjobs'), 'home.admin.cronjobs', 'glyph-img-setting'),
            this.createMenuItem(marker('Config Settings'), 'home.admin.config', 'glyph-img-setting')
        ];
        
        // Include Flow AI and Knowledge Index menu items only when enabled by feature flag
        if (this.featureFlagService.isFeatureEnabled('flow')) {
            const aiMenu = this.createMenuItem(marker('Flow AI'), 'home.admin.aiflow', 'glyph-img-gforge-flow');
            menuData.splice(3, 0, aiMenu);
            const kiMenu = this.createMenuItem(marker('Knowledge Index'), 'home.admin.knowledgeindex', 'glyph-img-gforge-flow');
            menuData.splice(4, 0, kiMenu);
        }

        if (this.featureFlagService.isFeatureEnabled('webhooks')) {
            const webhooksIdx = menuData.findIndex(m => m['state'] === 'home.admin.sitenotification');
            menuData.splice(webhooksIdx + 1, 0, this.createMenuItem(marker('Webhooks'), 'home.admin.webhooks', 'glyphicon glyphicon-flash'));
        }

        this.menuData = menuData;
    }

    public getMenuItemForState(stateName) {
        return this.menuData.find(function (m) {
            return _.startsWith(stateName, m.state);
        });
    }

    public getMenuData() {
        return this.menuData;
    }

    public getTitleForState(stateName) {
        return _.get(
            this.getMenuItemForState(stateName),
            'title', ''
        );
    }

    public getGlyphForState(stateName) {
        return _.get(
            this.getMenuItemForState(stateName),
            'glyph', 'glyph-img-user'
        );
    }

    public createMenuItem(title, stateName, glyphClasses) {
        return {
            title: this.gfTranslateService.translate(title),
            state: stateName,
            glyph: glyphClasses
        };
    }

    public menuSeparator = () => {
        return {};
    }
}